// apiUtils.js
import axios from 'axios';
export const BASE_URL = "https://anshu98.pythonanywhere.com";
// export const BASE_URL = "http://localhost:8000";
// export const BASE_URL = "https://dublin-lined-assessments-passage.trycloudflare.com/"

export const verifyPayment = async (itemOrderId,razorpayOrderId, razorpayPaymentId, razorpaySignature) => {
    try {
        const url = `${BASE_URL}/payment/verify-payment/`; // Dynamic URL
        const response = await axios.post(url, {
            razorpay_order_id: razorpayOrderId,
            razorpay_payment_id: razorpayPaymentId,
            razorpay_signature: razorpaySignature,
            item_order_id: itemOrderId,
        }, {
            headers: {
                'Content-Type': 'application/json',
            }
        });

        return response.data; // Return the response data
    } catch (error) {
        throw new Error('Failed to verify payment: ' + error.message);
    }
};

export const createOrder = async (amount, receipt) => {
    try {
        const url = `${BASE_URL}/payment/create-order/`; // Dynamic URL
        const response = await axios.post(url, {
            amount: amount,  // Replace this with the actual amount
            receipt: receipt // Replace with actual receipt
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return response.data; // Return the response data
    } catch (error) {
        throw new Error('Failed to create order: ' + error.message);
    }
};

export const updateDownloadTrend = async (accessToken, product_id) => {
    try {
        let url = `${BASE_URL}/products/items/${product_id}/handle-download/`;
        const response = await axios.post(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to update trends item.');
    }
};

export const fetchCategoriesByID = async (accessToken,id) => {
    try {
        console.log(id)
        let url = `${BASE_URL}/products/categories/${id}`;
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });
        console.log("response",response)
        return response.data;
    } catch (error) {
        throw new Error('Failed to get cart item.');
    }
};
export const updateCartItem = async (accessToken, itemId, quantity) => {
    try {
        let url = `${BASE_URL}/cart/cartitem/${itemId}/`;
        const response = await axios.patch(url, {
            quantity: quantity
        }, {
            headers: {
                'Authorization': 'Bearer ' + accessToken,
                'Content-Type': 'application/json'
            }
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to update cart item.',error);
    }
};

export const deleteCart = async (accessToken) => {
    try {
        let url = `${BASE_URL}/cart/cartitem/delete_cart/`;
        const response = await axios.delete(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to delete cart item.');
    }
};
export const deleteByProductCart = async (accessToken, product_id, quantity) => {
    try {
        let url = `${BASE_URL}/cart/cartitem/delete_cart_item_by_product/`;
        const response = await axios.post(url, {
            product_id: product_id,
            quantity:quantity,
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to create cart item.');
    }
};

export const Feedback = async (accessToken, body) => {
    try {
        let url = `${BASE_URL}/user_feedback/feedback/`;
        const response = await axios.post(url, body, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to create cart item.');
    }
};

export const checkoutCart = async (accessToken, detailsArray) => {
    try {
        let url = `${BASE_URL}/order/checkout/`;
        const response = await axios.post(url, detailsArray, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error(error);
    }
};

export const getAuthorById= async (accessToken,id=null) => {
    try {
        console.log(accessToken)
        let url = `${BASE_URL}/accounts/author/`;
        if (id!==null){
            url = `${BASE_URL}/accounts/author/${id}/`;
        }

        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });
        console.log("response",response.data)
        return response.data;
    } catch (error) {
        throw new Error('Failed to get cart item.');
    }
};
export const getAuthors= async (accessToken) => {
    try {
        console.log(accessToken)
        let url = `${BASE_URL}/accounts/author/`;
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });
        console.log("response",response.data)
        return response.data;
    } catch (error) {
        throw new Error('Failed to get cart item.');
    }
};
export const getAuthorByToken= async (accessToken) => {
    try {
        console.log(accessToken)
        let url = `${BASE_URL}/accounts/author/token/`;
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });
        console.log("response",response.data)
        return response.data;
    } catch (error) {
        throw new Error('Failed to get cart item.');
    }
};
export const getcheckoutCart = async (accessToken) => {
    try {
        let url = `${BASE_URL}/order/checkout/`;
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });
        console.log("response",response)
        return response.data;
    } catch (error) {
        throw new Error('Failed to get cart item.');
    }
};
export const createCart = async (accessToken, product_id, quantity) => {
    try {
        let url = `${BASE_URL}/cart/cartitem/`;
        const response = await axios.post(url, {
            product_id: product_id,
            quantity:quantity
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            }
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to create cart item.');
    }
};
export const userSignup = async (username, password,is_author) => {
    try {
        let url = `${BASE_URL}/accounts/signup/`;
        const response = await axios.post(url, {
            username: username, // Use the username state variable
            password: password, // Use the password state variable
            author:is_author,
        }, {
            headers: {
                'Content-Type': 'application/json',
                // 'Cookie': 'csrftoken=RQZ9ysMVV4p0o0PJDrKRDq7QQyGuhZfz',
            },
        });
        return response;
    } catch (error) {
        throw new Error('Failed to create cart item.');
    }
};

export const getCart = async (accessToken) => {
    try {
        let url = `${BASE_URL}/cart/cartitem/`;
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            },
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch products.');
    }
};

export const fetchProducts = async (accessToken, product_id) => {
    try {
        let url = `${BASE_URL}/products/items/`;
        if (product_id) {
            url += `?product_id=${product_id}`;
        }
        
        const response = await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            },
        });

        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch products.');
    }
};

export const fetchCategories = async (accessToken) => {
    try {
        const response = await axios.get(`${BASE_URL}/products/categories/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + accessToken
            },
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to fetch products.');
    }
};
export const updateAuthor = async (accessToken, authorId, formData) => {
    try {
        const response = await axios.patch(
            `${BASE_URL}/accounts/author/${authorId}/`,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'multipart/form-data'
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error(`Failed to update author: ${error.response?.data?.detail || error.message}${BASE_URL}accounts/author/${authorId}/`);
    }
};
export const uploadProduct = async (accessToken, formData) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/products/items/`,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'multipart/form-data', // Necessary for file uploads
                },
            }
        );
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.detail || error.message;
        throw new Error(`Failed to upload product: ${errorMessage}`);
    }
};
export const deleteProduct = async (accessToken, productId) => {
    try {
        const response = await axios.delete(
            `${BASE_URL}/products/items/${productId}/`,
            {
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        return response.data;
    } catch (error) {
        const errorMessage = error.response?.data?.detail || error.message;
        throw new Error(`Failed to delete product: ${errorMessage}`);
    }
};